var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtSchedulerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10156",
    "data-name": "Group 10156",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.032,
    height: 25.005,
    viewBox: "0 0 24.032 25.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18708",
    "data-name": "Rectangle 18708",
    width: 24.032,
    height: 25.005,
    fill: "#3d7cc9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10155",
    "data-name": "Group 10155",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6111",
    "data-name": "Path 6111",
    d: "M288.1,21.5l-.756-.216a2.086,2.086,0,0,0-.625-1.926,3.5,3.5,0,0,0-3.9-.925,1.568,1.568,0,0,0-.611.548l-.324-.2-.367-.167.026-.048a2.342,2.342,0,0,1,.91-.825,3.642,3.642,0,0,1,2.51-.247,4.61,4.61,0,0,1,2.335,1.333,2.854,2.854,0,0,1,.8,2.676",
    transform: "translate(-264.892 -16.406)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6112",
    "data-name": "Path 6112",
    d: "M282.417,6.78a3.852,3.852,0,0,1-1.575-.341,3.752,3.752,0,0,1-1.927-1.922A3.165,3.165,0,0,1,280.856.183a3.833,3.833,0,0,1,4.644,2.08A3.166,3.166,0,0,1,283.56,6.6a3.633,3.633,0,0,1-1.142.183M282,.786a2.847,2.847,0,0,0-.9.143A2.38,2.38,0,0,0,279.636,4.2a3.048,3.048,0,0,0,3.676,1.646,2.38,2.38,0,0,0,1.467-3.275,2.969,2.969,0,0,0-1.527-1.517A3.069,3.069,0,0,0,282,.786",
    transform: "translate(-262.176 0)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6113",
    "data-name": "Path 6113",
    d: "M170.327,19.124l-.193-1.845a.852.852,0,0,0-.868-.675l-1.328.023a.836.836,0,0,0-.834.7l-.1,1.633-.784-.047.1-1.636a1.624,1.624,0,0,1,1.6-1.44l1.328-.023a1.64,1.64,0,0,1,1.663,1.375l.193,1.848Z",
    transform: "translate(-156.891 -14.931)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18704",
    "data-name": "Rectangle 18704",
    width: 4.298,
    height: 0.786,
    transform: "translate(9.591 3.62)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6114",
    "data-name": "Path 6114",
    d: "M166.932,73.407a2.756,2.756,0,0,1-2.527-2.934,3.325,3.325,0,0,1,.122-.9l.756.213a2.539,2.539,0,0,0-.093.69,1.78,1.78,0,1,0,3.483,0,2.533,2.533,0,0,0-.093-.689l.756-.213a3.324,3.324,0,0,1,.122.9,2.756,2.756,0,0,1-2.527,2.934",
    transform: "translate(-155.177 -65.665)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6115",
    "data-name": "Path 6115",
    d: "M187.712,94.438h-.786V93.391h-1.175v1.047h-.786V92.605h2.746Z",
    transform: "translate(-174.584 -87.407)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18705",
    "data-name": "Rectangle 18705",
    width: 1.705,
    height: 0.786,
    transform: "matrix(0.651, -0.759, 0.759, 0.651, 12.437, 5.335)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18706",
    "data-name": "Rectangle 18706",
    width: 0.786,
    height: 1.668,
    transform: "translate(9.364 4.618) rotate(-42.157)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6116",
    "data-name": "Path 6116",
    d: "M130.639,143.558a.46.46,0,0,1-.393-.505v-1.464a1.991,1.991,0,0,0-1.989-1.989h-4.331a1.991,1.991,0,0,0-1.989,1.989v1.136a.405.405,0,1,1-.786,0v-1.136a2.778,2.778,0,0,1,2.775-2.775h4.331a2.778,2.778,0,0,1,2.775,2.775v1.464a.46.46,0,0,1-.393.505",
    transform: "translate(-114.352 -131.023)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6117",
    "data-name": "Path 6117",
    d: "M324.28,35.045a1.61,1.61,0,0,1-.654-.144,1.53,1.53,0,0,1-.711-.626.917.917,0,0,1,.63-1.407,1.6,1.6,0,0,1,1.652.74.917.917,0,0,1-.63,1.407,1.347,1.347,0,0,1-.287.03m-.45-1.645a.779.779,0,0,0-.166.017A.361.361,0,0,0,323.4,34a1.042,1.042,0,0,0,1.044.467.424.424,0,0,0,.305-.213h0a.424.424,0,0,0-.045-.369.981.981,0,0,0-.452-.39,1.057,1.057,0,0,0-.426-.095",
    transform: "translate(-303.836 -30.995)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6118",
    "data-name": "Path 6118",
    d: "M293.039,52.83h-.027a1.54,1.54,0,0,1-1.454-1.053.877.877,0,0,1,.158-.775,1.1,1.1,0,0,1,.9-.378h0a1.541,1.541,0,0,1,1.454,1.053.877.877,0,0,1-.158.775,1.093,1.093,0,0,1-.872.378m-.451-1.645a.543.543,0,0,0-.433.167.319.319,0,0,0-.052.29.988.988,0,0,0,.919.627.549.549,0,0,0,.449-.166.319.319,0,0,0,.052-.29.988.988,0,0,0-.919-.627h-.017",
    transform: "translate(-274.347 -47.782)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6119",
    "data-name": "Path 6119",
    d: "M334.172,70.231a1.645,1.645,0,0,1-1.18-.517h0a1.1,1.1,0,0,1-.316-.922.877.877,0,0,1,.473-.634,1.541,1.541,0,0,1,1.754.383,1.1,1.1,0,0,1,.317.922.877.877,0,0,1-.473.634,1.226,1.226,0,0,1-.574.134m-.768-.9a.987.987,0,0,0,1.08.268.32.32,0,0,0,.182-.232.551.551,0,0,0-.175-.446.988.988,0,0,0-1.08-.268.32.32,0,0,0-.181.232.551.551,0,0,0,.175.446",
    transform: "translate(-313.172 -64.206)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6121",
    "data-name": "Path 6121",
    d: "M18.863,21.5a2.854,2.854,0,0,1,.8-2.676A4.61,4.61,0,0,1,22,17.5a3.643,3.643,0,0,1,2.51.247,2.342,2.342,0,0,1,.91.825l.026.048-.367.167h0l-.323.2a1.567,1.567,0,0,0-.611-.548,3.5,3.5,0,0,0-3.9.925,2.085,2.085,0,0,0-.625,1.927Zm6.167-2.7-.3.135Z",
    transform: "translate(-18.464 -16.408)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6122",
    "data-name": "Path 6122",
    d: "M16.543,6.779A3.63,3.63,0,0,1,15.4,6.6a3.2,3.2,0,0,1-1.949-1.729A3.49,3.49,0,0,1,15.387.341,3.752,3.752,0,0,1,18.1.183a3.165,3.165,0,0,1,1.941,4.334,3.752,3.752,0,0,1-1.927,1.922,3.853,3.853,0,0,1-1.575.341M16.962.786a3.069,3.069,0,0,0-1.254.272,2.706,2.706,0,0,0-1.539,3.488,2.419,2.419,0,0,0,1.478,1.3A3.048,3.048,0,0,0,19.324,4.2,2.38,2.38,0,0,0,17.857.929a2.847,2.847,0,0,0-.9-.143",
    transform: "translate(-13.181 0)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6123",
    "data-name": "Path 6123",
    d: "M51.662,35.045a1.346,1.346,0,0,1-.287-.03.917.917,0,0,1-.63-1.407,1.6,1.6,0,0,1,1.652-.74.917.917,0,0,1,.63,1.407,1.53,1.53,0,0,1-.711.626,1.61,1.61,0,0,1-.654.144m.45-1.645a1.057,1.057,0,0,0-.426.095.98.98,0,0,0-.452.39.424.424,0,0,0-.045.369h0a.424.424,0,0,0,.305.213A1.042,1.042,0,0,0,52.538,34a.361.361,0,0,0-.261-.582.779.779,0,0,0-.166-.017",
    transform: "translate(-48.502 -30.995)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6124",
    "data-name": "Path 6124",
    d: "M82.876,52.83A1.093,1.093,0,0,1,82,52.452a.877.877,0,0,1-.158-.775A1.541,1.541,0,0,1,83.3,50.624h0a1.1,1.1,0,0,1,.9.378.877.877,0,0,1,.158.775A1.54,1.54,0,0,1,82.9,52.83h-.027m.434-1.645a.988.988,0,0,0-.919.627.319.319,0,0,0,.052.29.55.55,0,0,0,.449.166.987.987,0,0,0,.919-.627.319.319,0,0,0-.052-.29.558.558,0,0,0-.449-.166",
    transform: "translate(-77.965 -47.782)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6125",
    "data-name": "Path 6125",
    d: "M41.755,70.229a1.226,1.226,0,0,1-.574-.134.877.877,0,0,1-.473-.634,1.1,1.1,0,0,1,.317-.922,1.541,1.541,0,0,1,1.754-.383.877.877,0,0,1,.473.634,1.1,1.1,0,0,1-.316.922h0a1.645,1.645,0,0,1-1.18.517m.45-1.647a1.091,1.091,0,0,0-.768.338.551.551,0,0,0-.175.446.32.32,0,0,0,.182.232.988.988,0,0,0,1.08-.268.551.551,0,0,0,.175-.446.32.32,0,0,0-.182-.232.668.668,0,0,0-.312-.07",
    transform: "translate(-39.152 -64.205)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6126",
    "data-name": "Path 6126",
    d: "M3.04,226.171v-1.123h12.5a1.1,1.1,0,0,0,.817-.269,1.049,1.049,0,0,0,.254-.648v-.666a1.929,1.929,0,0,0-.556-1.419,2.755,2.755,0,0,0-1.949-.7H6.988l-3.973.352-2.443.268a.505.505,0,0,1-.557-.447L0,221.4a.505.505,0,0,1,.447-.557l2.46-.27,4.029-.357h7.173a3.823,3.823,0,0,1,2.741,1.033,3.053,3.053,0,0,1,.885,2.213v.646a2.144,2.144,0,0,1-.572,1.451,2.168,2.168,0,0,1-1.621.608Z",
    transform: "translate(0 -207.858)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6127",
    "data-name": "Path 6127",
    d: "M.669,290.57a.505.505,0,0,1-.505-.505v-.112a.505.505,0,0,1,.505-.505H1.5v1.123Z",
    transform: "translate(-0.155 -273.201)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6128",
    "data-name": "Path 6128",
    d: "M16.225,278.472c-1.277,0-2.24-.611-2.24-1.422a.966.966,0,0,1,.118-.462,2.363,2.363,0,0,1,2.122-.958H27.2a.505.505,0,0,1,.505.505v.112a.505.505,0,0,1-.505.505H16.225a.582.582,0,1,0,0,.6h12.52v1.123Z",
    transform: "translate(-13.2 -260.159)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6129",
    "data-name": "Path 6129",
    d: "M327.869,243.617a2.36,2.36,0,1,1,2.677-2.338,2.527,2.527,0,0,1-2.677,2.338m0-3.554a1.252,1.252,0,1,0,1.554,1.216,1.418,1.418,0,0,0-1.554-1.216",
    transform: "translate(-306.939 -225.53)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18707",
    "data-name": "Rectangle 18707",
    width: 1.123,
    height: 3.11,
    transform: "translate(6.09 12.922)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6130",
    "data-name": "Path 6130",
    d: "M.669,338.186a.505.505,0,0,1-.505-.505v-.112a.505.505,0,0,1,.505-.505H22.125c.509,0,.94-.316.94-.69s-.43-.69-.94-.69H.669a.505.505,0,0,1-.505-.505v-.112a.505.505,0,0,1,.505-.505H22.125a1.827,1.827,0,1,1,0,3.625Z",
    transform: "translate(-0.155 -315.783)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6131",
    "data-name": "Path 6131",
    d: "M223.762,392.3h-.112a.505.505,0,0,1-.505-.505v-2.658h1.123v2.658a.505.505,0,0,1-.505.505",
    transform: "translate(-210.62 -367.294)",
    fill: "#3d7cc9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtSchedulerIcon);
export default __webpack_public_path__ + "static/media/otSchedulerIcon.014f32c41d6079f7dc548aaf83da19de.svg";
export { ForwardRef as ReactComponent };